import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CurrentFarmState } from '../_reducers/currentFarm';

export const selectCurrentFarmState = createFeatureSelector<CurrentFarmState>('currentFarm');

export const selectCurrentFarm = createSelector(
  selectCurrentFarmState,
  (state: CurrentFarmState) => state.farm
);

export const selectCurrentFarmLoading = createSelector(
  selectCurrentFarmState,
  (state: CurrentFarmState) => state.loading
);

export const selectCurrentFarmError = createSelector(
  selectCurrentFarmState,
  (state: CurrentFarmState) => state.error
);
